"use client";

import { c as _c } from "react/compiler-runtime";
import { FiLoader } from "react-icons/fi";
import { getFileIcon } from "@/lib/file-utils";
import { cx } from "@/lib/tailwind-utils";
import type { DocumentSummary } from "@/types/document";
interface DocumentThumbnailProps {
  document: DocumentSummary;
  signedUrl?: string;
  /**
   * Whether the card is currently on (or near) screen. Off-screen cards never
   * mount the live <img>/<iframe> — they show a neutral placeholder instead, so
   * we don't keep dozens of PDF viewers alive. Defaults to true so the component
   * stays usable outside the lazy grid.
   */
  isInView?: boolean;
  isLoading?: boolean;
  className?: string;
}
function isImageFile(fileType: string) {
  const lowerType = fileType.toLowerCase();
  return lowerType.includes("image") || lowerType.includes("png") || lowerType.includes("jpg") || lowerType.includes("jpeg");
}
function isPdfFile(fileType: string) {
  return fileType.toLowerCase().includes("pdf");
}
export function withPdfPreviewParams(url: string) {
  const separator = url.includes("#") ? "&" : "#";
  return `${url}${separator}toolbar=0&navpanes=0&scrollbar=0&page=1&view=FitH`;
}
export function canPreviewDocumentThumbnail(fileType: string) {
  return isImageFile(fileType) || isPdfFile(fileType);
}
export default function DocumentThumbnail(t0) {
  const $ = _c(20);
  const {
    document,
    signedUrl,
    isInView: t1,
    isLoading: t2,
    className
  } = t0;
  const isInView = t1 === undefined ? true : t1;
  const isLoading = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== document.fileType) {
    t3 = isImageFile(document.fileType);
    $[0] = document.fileType;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const isImage = t3;
  let t4;
  if ($[2] !== document.fileType) {
    t4 = isPdfFile(document.fileType);
    $[2] = document.fileType;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isPdf = t4;
  let t5;
  if ($[4] !== document.fileType) {
    t5 = canPreviewDocumentThumbnail(document.fileType);
    $[4] = document.fileType;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const canPreview = t5;
  const previewUnavailable = canPreview && isInView && !isLoading && !signedUrl;
  let t6;
  if ($[6] !== className) {
    t6 = cx("relative flex aspect-[4/3] min-h-0 w-full overflow-hidden rounded-md border border-border bg-background-secondary", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== document.fileType || $[9] !== document.title || $[10] !== isImage || $[11] !== isInView || $[12] !== isLoading || $[13] !== isPdf || $[14] !== previewUnavailable || $[15] !== signedUrl) {
    t7 = isInView && isLoading ? <div className="flex flex-1 items-center justify-center"><FiLoader className="h-5 w-5 animate-spin text-foreground-muted" /></div> : isImage && isInView && signedUrl ? <img src={signedUrl} alt={document.title} className="h-full w-full object-cover" loading="lazy" /> : isPdf && isInView && signedUrl ? <div className="h-full w-full overflow-hidden bg-background"><iframe src={withPdfPreviewParams(signedUrl)} title={`${document.title} preview`} className="pointer-events-none h-full w-full origin-center scale-[1.06] bg-background" loading="lazy" tabIndex={-1} /></div> : <div className={cx("flex flex-1 flex-col items-center justify-center gap-2 text-foreground-muted", previewUnavailable && "text-status-error-text")}>{getFileIcon(document.fileType)}<span className={cx("text-caption", previewUnavailable ? "text-status-error-text" : "text-muted-foreground")}>{previewUnavailable ? "Preview unavailable" : "No preview"}</span></div>;
    $[8] = document.fileType;
    $[9] = document.title;
    $[10] = isImage;
    $[11] = isInView;
    $[12] = isLoading;
    $[13] = isPdf;
    $[14] = previewUnavailable;
    $[15] = signedUrl;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}